var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sh-skeleton"},[_c('skeleton-loading',[_c('img',{attrs:{"src":require("@/assets/skeleton/graph-skeleton.svg"),"alt":"","srcset":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }